export const ApplicationModuleQuestions = [
    {
        header: 'LENKA SE ROZHODLA PODAT PŘIHLÁŠKU VYNÁLEZU U ÚŘADU PRŮMYSLOVÉHO VLASTNICTVÍ. JAK MÁ POSTUPOVAT?',
        answers: [
            {
                content: 'Podávat přihlášku vynálezu nemá téměř cenu, protože pravděpodobnost, že s ní uspěje, je velmi malá.',
            },
            {
                content: 'Lenka si musí stáhnout formulář na stránkách Úřadu průmyslového vlastnictví. Je interaktivní a stačí ho důkladně vyplnit a zaplatit poplatek.',
            },
            {
                content: 'Je vhodné přihlášku nechat vypracovat patentovému zástupci – jedná se o poměrně složitou záležitost, která vyžaduje specifický jazyk. Zvýšení nákladů o práci patentového zástupce se určitě vyplatí.',
                correct: true,
            },
        ],
    },
    {
        header: 'LENKA MÁ PŘIPRAVENÉ PODÁNÍ PŘIHLÁŠKY A SOUČASNĚ JE POŽÁDÁNA O PŘÍSPĚVEK NA MEZINÁRODNÍ KONFERENCI, KDE BY MĚLA S PODSTATOU SVÉHO NOVÉHO ŘEŠENÍ SEZNÁMIT VĚDECKOU KOMUNITU. CO MÁ UDĚLAT?',
        answers: [
            {
                content: 'Je zapotřebí, aby patentovou přihlášku podala před vlastní přednáškou na konferenci. Pakliže by sborník z konference či vlastní přednáška byly jakkoliv zveřejněny před datem podání přihlášky, už by byly brány jako stav techniky.',
                correct: true,
            },
            {
                content: 'Vědeckým konferencím, jejichž sborníky jsou evidovány v databázi WoS a SCOPUS, jsou uděleny výjimky z porušení novosti. Lenka může bez problémů přednášku.',
            },
            {
                content: 'Stačí zaslat upozornění na Úřad průmyslového vlastnictví, který je zanese do evidence. Pak je možné informace o technickém řešení zveřejnit.',
            },
        ],
    },
    {
        header: 'DÍKY NEDOSTATEČNÉ KOMUNIKACI DOŠLO K TOMU, ŽE TECHNICKÉ ŘEŠENÍ BYLO ZVEŘEJNĚNO VE SBORNÍKU MEZINÁRODNÍ VĚDECKÉ KONFERENCE DVA DNY PŘED PODÁNÍM PATENTOVÉ PŘIHLÁŠKY. DÁ SE V TOMTO PŘÍPADĚ NĚCO DĚLAT?',
        answers: [
            {
                content: 'Nedá se dělat nic. Tím je porušena zásad novosti. ',
            },
            {
                content: 'Patentovou přihlášku již bohužel podat nelze. Jedná-li se však o technické řešení (nikoliv o činnost – tj. postup, způsob anebo užití), pak můžeme podat ještě užitný vzor – a to do šesti měsíců od zveřejnění stavu techniky. Pro užitný vzor totiž stavem techniky není zveřejnění technického řešení, šest měsíců před podáním přihlášky, pakliže jsme toto zveřejnění provedli jako přihlašovatel my.',
                correct: true,
            },
            {
                content: 'Patentovou přihlášku podat můžeme, protože sborníky mezinárodních konferencí mají výjimku na porušení novosti.',
            },
        ],
    },
    {
        header: 'PAVEL, VĚDECKÝ PRACOVNÍK NA FAKULTĚ, NAHLÁSIL „PODNIKOVÝ“ VYNÁLEZ. VYSOKÁ ŠKOLA NA NĚJ UPLATNILA PRÁVO A ZAČALA VE SPOLUPRÁCI S PATENTOVÝM ZÁSTUPCEM ŘEŠIT PATENTOVOU PŘIHLÁŠKU. PŘED PODÁNÍM PŘIHLÁŠKY VŠAK PAVEL V ROZPORU S VNITŘNÍMI PŘEDPISY VYSOKÉ ŠKOLY PODSTATU VYNÁLEZU ZVEŘEJNIL VE SBORNÍKU MEZINÁRODNÍ KONFERENCE. JE TÍM PORUŠENA ZÁSADA NOVOSTI?',
        answers: [
            {
                content: 'Ano, každé zveřejnění znamená porušení novosti. Nemá na to vliv skutečnost, že zveřejnění nastalo díky porušení práv přihlašovatele. ',
            },
            {
                content: 'Sice došlo ke zveřejnění, ale případy, kdy došlo při zveřejnění k porušení práv přihlašovatele, novost se neztrácí. Jedná se například o porušení smlouvy o mlčenlivosti ze strany obchodního partnera anebo porušení vnitřních předpisů u zaměstnance.',
                correct: true,
            },
            {
                content: 'Ke zveřejnění v tomto případě nedošlo, protože sborníky mezinárodních vědeckých konferencí mají uděleny od roku 2002 výjimku z porušení novosti.',
            },
        ],
    },
];
